import React from 'react';
import useSelectedDoc from './useSelectedDoc';
import Loading from '../../../../Loading';
import styled from 'styled-components';
import ProgressField from './ProgressField';

const Card = styled.div`
  background-color: var(--color-bg-primary);
  padding: 16px;
  border: 1px solid var(--color-grey-7);
  border-radius: 4px;
  box-shadow: 0 3px 3px 0 rgba(53, 45, 67, 0.07);
  margin-bottom: 8px;
`;

const TargetProgressContainer = ({
  section,
}: {
  section: PerformanceBoardTypes.SlideOut.TargetProgressSection;
}) => {
  const { selectedDoc, isLoading } = useSelectedDoc();

  if (isLoading || !selectedDoc) {
    return <Loading />;
  }

  return (
    <Card>
      {section.fields.map((field, index) => (
        <div
          key={`${field}-${index}`}
          style={{ marginBottom: section.fields.length - 1 === index ? 0 : 4 }}
        >
          <ProgressField field={field} selectedDoc={selectedDoc} key={field} />
        </div>
      ))}
    </Card>
  );
};

export default TargetProgressContainer;
